/**
 * Phone number sanitization functions
 */

export const sanitizePhoneNumber = (phoneNumber: string): string => {
  // Remove all non-digit characters
  const digitsOnly = phoneNumber.replace(/\D/g, "");

  // Remove leading 1 if it's 11 digits (US country code)
  if (digitsOnly.length === 11 && digitsOnly.startsWith("1")) {
    return digitsOnly.substring(1);
  }

  return digitsOnly;
};

export const sanitizePhoneNumbers = (phoneNumbers: string[]): string[] => {
  return phoneNumbers
    .map((phone) => sanitizePhoneNumber(phone))
    .filter((phone) => phone.length === 10); // Only keep valid 10-digit numbers
};

